import "./video.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";
export default function KnowUsBetter() {
  return (
    <section className="videosection">
      <div className="styles-header">
        <h2>Know Us Better</h2>
        <p>See our journeys, travelers & real experiences</p>
      </div>

      {/* Video Grid */}
      <div className="videosection-inside">
      <div className="videoGrid">
        <video src="/video/video1dslr.mp4"  autoPlay loop muted playsInline preload="none" poster="/video/Capture2.JPG" />
         <video src="/video/first.mp4"  autoPlay loop muted playsInline  preload="none" poster="/video/first.JPG" />
          <video src="/video/le.mp4"  autoPlay loop muted playsInline  preload="none" poster="/img/mounteve/moun1.webp" />
          <video src="/video/L.mp4"  autoPlay loop muted playsInline  preload="none" poster="/video/Capture3.JPG" /> 
      </div>
      </div>
      {/* Social Media */}
      <div className="social">
        <p>Follow us on social media</p>
        <div className="socialicons">
          <Link to="https://www.facebook.com/profile.php?id=61590545644233" target="_blank"><FontAwesomeIcon icon={faFacebook}></FontAwesomeIcon></Link>
          <Link to="https://www.instagram.com/himalayastravelsofficial/" target="_blank"><FontAwesomeIcon icon={faInstagram}></FontAwesomeIcon></Link>
          <Link to="https://www.youtube.com/channel/UCj-bEPS5hTJ-vcvdWlH6Cbg" target="_blank"><FontAwesomeIcon icon={faYoutube}></FontAwesomeIcon></Link>
          <Link to="https://www.tiktok.com/@himalayastravelsofficial" target="_blank"><FontAwesomeIcon icon={faTiktok}></FontAwesomeIcon></Link>
        </div>
      </div>
    </section>
  );
}